import { Link } from 'react-router-dom';
import './details.less';
import { React, Component, Container, Config, _ } from 'utils';
import { ActiveResumeStore, CreditStore, Creators } from 'model';
import Page from '../Page';
import CampaignSelector from './campaignselector';
import PageTitle from '../pagetitle';
import NoCredits from '../NoCredits'
import moment from 'moment/src/moment';


function moveActiveResume(toFolder) {
	const resume = ActiveResumeStore.getState().resume;
	Creators.move([resume], toFolder);
}

class DetailsContainer extends Component {

	static getStores() {
		return [
			ActiveResumeStore,
			CreditStore,
		];
	}

	static calculateState() {
		return ({ 
			resume: ActiveResumeStore.getState(),
			credits: CreditStore.getState()
		});
	}

	componentWillMount() {
		Creators.loadResume(this.props.id);
	}

	componentDidMount = () => {
		$(document).on('create-folder', this.handleOpen);
		$('[data-toggle="tooltip"]').tooltip();
	}

	componentWillUnmount() {
		$(document).off('create-folder', this.handleOpen);
		$('[data-toggle="tooltip"]').tooltip('destroy');
	}

	handlePrintProfile() {
		window.print();
	}

	render() {
		const { resume, credits } = this.state;
	
		const ActionBar = (!resume.forbidden || credits.total <= 0) && (
			<div className="page-actions bulk-actions">
				<div className="backlink">
					<Link className="btn btn-gray" to={Config.baseUrl}>
						<i className="fa fa-caret-left" aria-hidden="true"></i>{' '}
						<span>{_('Baza životopisa')}</span>
					</Link>
				</div>

				{ credits.total > 0 && (
					<CampaignSelector
						onSelect={moveActiveResume}
						show={true}
						className="btn btn-primary"
					/>
				)}

				{ credits.total > 0 && (
					<button
						className="btn btn-default"
						data-toggle="tooltip"
						data-placement="bottom"
						title={_('Ispiši životopis')}
						onClick={() => this.handlePrintProfile()}
					>
						<i className="fa fa-print" aria-hidden="true"></i>
					</button>
				)}
			</div>
		);

		const Loading = (
			<div className="loading">
				<div className="text-center">{ _('Učitavam životopis') }</div>
				<div className="progress">
					<div className="progress-bar progress-bar-striped active" style={{ width: '100%' }}>
						<span className="sr-only"></span>
					</div>
				</div>
			</div>
		);

		let View = Loading;
		if (resume.forbidden) {
			View = (
				<NoCredits
					message={_('Iskoristili ste sve kredite!')}
					buyUrl={this.props.buyUrl}
				/>
			);
		} else if (resume.resume !== null && resume.loading === false) {
			if (credits.total <= 0) {
				View = (
					<NoCredits
						message={_('Iskoristili ste sve kredite!')}
						buyUrl={this.props.buyUrl}
					/>
				);
			} else {
				View = (
					<Details data={resume} />
				);
			}
		}

		return (
			<Page name="resume">
				<PageTitle />
				{ActionBar}
				{View}
			</Page>
		);
	}
}

export class Details extends Component {

	componentDidMount() {
		$('html, body').animate({ scrollTop: 0 });
	}

	render() {
		var { resume } = this.props.data;

		var vPhone = '';

		if(resume.phone) {
			vPhone = <div className="panel panel-default">
				<div className="body-info">
					<i className="fa fa-phone-square"></i>
					{resume.phone}
				</div>
				<div className="clearfix"></div>
			</div>;
		}

		var vEmail = '';

		if(resume.email) {
			vEmail = <div className="panel panel-default">
				<div className="body-info">
					<i className="fa fa-envelope"></i>
					{resume.email}
				</div>
				<div className="clearfix"></div>
			</div>;
		}

		return <div className="row resume-details">
			<div className="col-md-12">
				<div className="row profile">
					<div className="image pull-left">
						<Image model={resume} />
					</div>
					<div className="details pull-left">
						<h3>{resume.first_name + ' ' + resume.last_name}</h3>
						<div className="address">
							<div>{ [resume.zip + ' ' + resume.location, resume.country_id].join(',') }</div>
							<div>{ _('Godina rođenja')}: {resume.dob }</div>
							<div>{ resume.qualification }</div>
						</div>
						<div className="panel-info">{ vPhone }</div>
						<div className="panel-info">{ vEmail }</div>
					</div>
				</div>
			</div>
			<div className="col-md-8">
				<Summary model={resume} />
				<Experience model={resume} />
				<Education model={ resume.education } />
				<Other model={resume} />

			</div>
			<div className="col-md-4 sidebar">
				<Ecdl model={ resume } />
				<Languages model={ resume.languages } />
				<Skills model={ resume.skills } />
				<Licence model={ resume.driving_categories } />
				<Salary model={ resume } />
				<IdealJob model={ resume } />
			</div>
		</div>;
	}
}

function Summary({ model }) {
	
	if (model.summary || model.keywords) {

		const summary = model.summary && ([
			<h4 key="sum1">{_('Naslov profila')}</h4>,
			<div key="sum2">{ model.summary }</div>
		]);

		const keywords = model.keywords && ([
			<h4 key="kw1">{_('Ključne riječi')}</h4>,
			<div key="kw2">{ model.keywords }</div>
		]);

		return (
			<div className="panel panel-default summary">
				<div className="panel-body">
					{summary}
					{keywords}
				</div>
			</div>
		);
	}

	return null;
}

function IdealJob({ model }) {

	var parts = [];
	var { areas, categories, job_types } = model;

	if(job_types && job_types.length > 0) {
		var items = job_types.map(function(item) {
			return <div key={item.id}>{item.description}</div>
		});

		var view = <div key="job_types" className="details">
			<div><strong>{_('Prihvatljive vrste zaposlenja')}</strong></div>
			{ items }
		</div>;

		parts.push(view);
	}

	if(categories && categories.length > 0) {
		var items = categories.map(function(item) {
			return <div key={item.id}>{item.description}</div>
		});

		var view = <div key="categories" className="details">
			<div><strong>{_('Kategorije')}</strong></div>
			{ items }
		</div>

		parts.push(view);
	}

	if(areas && areas.length > 0) {
		var items = areas.map(function(item) {
			return <div key={item.id}>{item.description}</div>
		});

		var view = <div key="zupanije" className="details">
			<div><strong>{_('Županije')}</strong></div>
			{ items }
		</div>

		parts.push(view);
	}

	if(parts.length > 0) {
		return <div className="ideal-job">
			<h6>{_('Idealno radno mjesto')}</h6>
			<div className="panel panel-default">
				<div className="panel-body">{ parts }</div>
			</div>
		</div>
	} else {
		return null;
	}

}

function Icon({ name }) {
	var name = 'glyphicon glyphicon-' + name;
	return <span className={name}></span>
}

function Stars({ count, max }) {
	var items = [];

	for(var i=0; i<count; i++) {
		items.push(<i key={i} className="fa fa-star"></i>);
	}

	for(var i=count; i<max; i++){
		items.push(<i key={i} className="fa fa-star-o"></i>);
	}

	return <div className="stars">
		{items}
	</div>
}

function Ecdl({ model }) {
	var parts = [];

	if(model.ecdl) {
		var view = <div key="ecdl" className="list-group-item">
			<div className="icon-panel">
				<i className="fa fa-laptop"></i>
				<div className="icon-body">{_('ECDL diploma')}</div>
			</div>
		</div>;

		parts.push(view);
	}

	if(model.managerial_experience === 'true') {
		var view = <div key="managerial" className="list-group-item">
			<div className="icon-panel">
				<i className="fa fa-users"></i>
				<div className="icon-body">{_('Menadžersko iskustvo')}</div>
			</div>
		</div>;

		parts.push(view);
	}

	if(parts.length > 0) {
		return <div className="list-group ecdl">
			{parts}
		</div>
	}else{
        return null;
    }
}

function Salary({ model }) {

	var parts = [];

	if(model.ideal_job_salary_from) {
		var view = <span key="from"><strong>{model.ideal_job_salary_from}</strong>{_('kn')}</span>
		parts.push(view);
	}

	if(model.ideal_job_salary_to) {
		if(parts.length > 0) {
			parts.push(<span key="separator"> - </span>);
		}

		parts.push(<span key="to"><strong>{model.ideal_job_salary_to}</strong>{_('kn')}</span>)
	}


	if(parts.length > 0) {
		return <div className="salary-range">
			<h6>{_('Očekivana plaća')}</h6>
			<div className="list-group">
				<div className="list-group-item">
					<div className="icon-panel">
						<i className="fa fa-google-wallet"></i>
						<div className="icon-body">{ parts }</div>
					</div>
				</div>
			</div>
		</div>;
	} else {
		return null;
	}
}

function Licence({ model }) {

	if(model && model.length > 0) {
		return <div className="driving-licence">
			<h6>{_('Vozačka dozvola')}</h6>
			<div className="list-group">
				<div className="list-group-item">
					<strong>{_('Kategorije')}</strong>
					<div className="icon-panel">
						<i className="fa fa-car"></i>
						<div className="icon-body">{ model.join(', ') }</div>
					</div>
				</div>
			</div>
		</div>;
	} else {
		return null;
	}

}

function Languages({ model }) {
	var items = model.map(function(item, index) {
		return <div key={index} className="list-group-item language">
			<div className="row">
				<div className="col-md-6">
					<h5>{ item.desc }</h5>
					<div>{ item.info }</div>
				</div>
				<div className="col-md-6">
					<Stars count={item.level} max={4} />
				</div>
			</div>
		</div>
	});

	if(model && model.length > 0) {
		return <div>
			<h6>{_('Jezici')}</h6>
			<div className="list-group">
				{items}
			</div>
		</div>;
	} else {
		return null;
	}
}

function Skills({ model }) {

	if(model && model.length > 0) {

		var items = model.map(function(item, index) {
			return <div key={index} className="list-group-item">
				<div className="row">
					<div className="col-md-6">
						<h5>{ item.name }</h5>
						<div>{ item.info }</div>
					</div>
					<div className="col-md-6">
						<Stars count={ item.level } max={3} />
					</div>
				</div>
			</div>
		});

		return <div>
				<h6>{_('Vještine')}</h6>
				<div className="skills list-group">
					{items}
				</div>
			</div>
	} else {
		return null;
	}
}

function Education({ model }) {
	var es = model.map(function(item) {
		var endDate = (item.date_end)?format(item.date_end):_('danas');

		return <div key={item.id} className="row item">
			<div className="col-md-4">
				<h4>
					{ [format(item.date_start), endDate].join(' - ') }
					<span className="graduation"><i className="fa fa-graduation-cap"></i></span>
				</h4>
			</div>
			<div className="col-md-8">
				<h4>{item.title}</h4>
				<div>{item.description}</div>
			</div>
		</div>
	});

	if (es.length) {
		return (
			<div className="education section">
				<h3><i className="fa fa-angle-right"></i>{_('Obrazovanje')}</h3>
				{es}
			</div>
		);
	}

	return null;
}

function format(date) {
	return moment(date).format('YYYY/MM');
}

function Experience({ model }) {

	var ws = model.work_experience.map(function(item) {
		var circleCss = ['circle'];

		if(!item.date_end) {
			circleCss.push('active');
		}

		var endDate = (item.date_end)?format(item.date_end):_('danas');

		return <div key={item.id} className="row item">
			<div className="col-md-4">
				<h4>{ format(item.date_start) + ' - ' + endDate }
					<span className={ circleCss.join(' ') }>
						<span></span>
					</span>
				</h4>
			</div>
			<div className="col-md-8">
				<h4>{ item.position }</h4>
				<div className="company-details">
					<div>{ item.company }</div>
					<div>{ [item.location, item.country_id ].join(', ') }</div>
				</div>
				<div className="description">{ item.description }</div>
			</div>
		</div>
	});

	if (model.work_experience.length) {
		return (
			<div className="experience section">
				<h3><i className="fa fa-angle-right"></i>{_('Radno iskustvo')}</h3>
				{ws}
			</div>
		);
	}

	return null;
}

function Other({ model }) {
	var { achievements, ambitions, hobbies, info } = model;
	var parts = [];

	if(achievements) {
		let view = <div key="achivements" className="row item">
			<div className="col-md-4">
				<h4>{_('Dostignuća')}</h4>
			</div>
			<div className="col-md-8">
				{achievements}
			</div>
		</div>;

		parts.push(view);
	}

	if(ambitions) {
		let view = <div key="ambitions" className="row item">
			<div className="col-md-4">
				<h4>{_('Ambicije i ciljevi u karijeri')}</h4>
			</div>
			<div className="col-md-8">
				{ambitions}
			</div>
		</div>;

		parts.push(view);
	}

	if(hobbies) {
		let view = <div key="hobbies" className="row item">
			<div className="col-md-4">
				<h4>{_('Interesi, hobiji ...')}</h4>
			</div>
			<div className="col-md-8">
				{hobbies}
			</div>
		</div>;

		parts.push(view);
	}

	if(info) {
		let view = <div key="additional-info" className="row item">
			<div className="col-md-4">
				<h4>{_('Dodatne informacije')}</h4>
			</div>
			<div className="col-md-8">
				{info}
			</div>
		</div>;

		parts.push(view);
	}

	if(parts.length > 0) {
		return <div className="other section">
			<h3><i className="fa fa-angle-right"></i>{_('Ostale informacije')}</h3>
			{parts}
		</div>
	} else {
		return null;
	}

}

class Image extends Component {

	handleProfileImageLoadError(event) {
		const FALLBACK_IMAGE = "http://s.moj-posao.org/data/images/preview/design/portrait-crop-160x160x100.png";
		event.currentTarget.src = FALLBACK_IMAGE;
	}

	render() {
		const { model } = this.props;

		if(model.image) {
			return (
				<img 
					src={model.image}
					onError={(e) => this.handleProfileImageLoadError(e)}
					onAbort={(e) => this.handleProfileImageLoadError(e)}
				/>
			);
		} else {
			return <img src="http://s.moj-posao.org/data/images/preview/design/portrait-crop-160x160x100.png" />
		}
	}
}

export default Container.create(DetailsContainer);



// WEBPACK FOOTER //
// ./src/modules/app/resumes/Details.js